/*
 * AMFA delivery estimate
 * Recognises an Eircode (or a UK postcode), maps it to a delivery zone and
 * counts working days from the next dispatch in Irish time. Weekends, Irish
 * public holidays and the merchant's own closure dates are skipped.
 * Everything is configured on the "Delivery estimate" block in the theme editor.
 */
(function () {
  if (window.AmfaDelivery) return;

  var DAY = 86400000;
  function utc(y, m, d) { return new Date(Date.UTC(y, m, d, 12)); }
  function addDays(d, n) { return new Date(d.getTime() + n * DAY); }
  function key(d) { return d.toISOString().slice(0, 10); }

  /* ---- Irish public holidays (any year; fixed dates on a weekend move to the next free weekday) ---- */
  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return utc(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
  }
  function firstMonday(y, mon) { var d = utc(y, mon, 1); return addDays(d, (8 - d.getUTCDay()) % 7); }
  function lastMonday(y, mon) { var d = utc(y, mon + 1, 0); return addDays(d, -((d.getUTCDay() + 6) % 7)); }
  /* St Brigid's Day: first Monday in February, or 1 February when that falls on a Friday */
  function brigid(y) { var f = utc(y, 1, 1); return f.getUTCDay() === 5 ? f : firstMonday(y, 1); }

  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var set = {};
    var fixed = [utc(y, 0, 1), utc(y, 2, 17), utc(y, 11, 25), utc(y, 11, 26)];
    var moving = [brigid(y), addDays(easterSunday(y), 1), firstMonday(y, 4), firstMonday(y, 5), firstMonday(y, 7), lastMonday(y, 9)];
    fixed.concat(moving).forEach(function (d) { set[key(d)] = true; });
    fixed.forEach(function (d) {
      var w = d.getUTCDay();
      if (w !== 0 && w !== 6) return;
      var s = addDays(d, 1);
      while (s.getUTCDay() === 0 || s.getUTCDay() === 6 || set[key(s)]) s = addDays(s, 1);
      set[key(s)] = true;
    });
    return (holidayCache[y] = set);
  }

  function calendar(closures) {
    var closed = {};
    String(closures || '').split(/[\s,;]+/).forEach(function (s) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) closed[s] = true;
    });
    function isWorking(d) {
      var w = d.getUTCDay();
      if (w === 0 || w === 6) return false;
      return !holidays(d.getUTCFullYear())[key(d)] && !closed[key(d)];
    }
    function nextWorking(d) { var n = addDays(d, 1); while (!isWorking(n)) n = addDays(n, 1); return n; }
    function addWorking(d, count) { var n = d; for (var i = 0; i < count; i++) n = nextWorking(n); return n; }
    return { isWorking: isWorking, nextWorking: nextWorking, addWorking: addWorking };
  }

  /* Today's date and the time of day in Ireland, whatever timezone the shopper is in */
  function irishNow(date) {
    var o = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Dublin', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(date || new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { date: utc(+o.year, +o.month - 1, +o.day), minutes: (+o.hour % 24) * 60 + (+o.minute) };
  }

  /* ---- Postcodes: Eircode first, then Northern Ireland, then Great Britain ---- */
  var EIRCODE = /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)([0-9AC-FHKNPRTV-Y]{4})?$/;
  var NI = /^BT[0-9]{1,2}([0-9][ABD-HJLNP-UW-Z]{2})?$/;
  var GB = /^([BEGLMNSW]|[A-PR-UWYZ][A-HK-Y])[0-9][A-Z0-9]?([0-9][ABD-HJLNP-UW-Z]{2})?$/;

  function normalize(v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function keyList(s) { return String(s || '').toUpperCase().split(/[\s,;]+/).filter(Boolean); }
  function spaceUK(v) { return v.replace(/^(.+)([0-9][A-Z]{2})$/, '$1 $2'); }

  function classify(input, cfg) {
    var v = normalize(input);
    if (!v) return { error: 'empty' };
    var zones = {};
    (cfg.zones || []).forEach(function (z) { zones[z.id] = z; });

    var m = v.match(EIRCODE);
    if (m) {
      var routing = m[1];
      var zone = ['ie1', 'ie2'].map(function (id) { return zones[id]; }).filter(function (z) {
        return z && keyList(z.keys).some(function (k) { return routing.indexOf(k) === 0; });
      })[0] || zones.ie3;
      return { zone: zone, formatted: m[2] ? routing + ' ' + m[2] : routing };
    }
    if (NI.test(v)) {
      return zones.ni && zones.ni.enabled !== false ? { zone: zones.ni, formatted: spaceUK(v) } : { error: 'unsupported' };
    }
    if (GB.test(v) && v.indexOf('BT') !== 0) {
      return zones.gb && zones.gb.enabled !== false ? { zone: zones.gb, formatted: spaceUK(v) } : { error: 'unsupported' };
    }
    return { error: 'invalid' };
  }

  /* ---- Dates: dispatch today before the cut-off on a working day, then count working days in transit ---- */
  function estimate(zone, cfg, now) {
    var cal = calendar(cfg.closures);
    now = now || irishNow();
    var cutoff = (Number(cfg.cutoff) || 0) * 60;
    var processing = Number(cfg.processing) || 0;
    var sameDay = cal.isWorking(now.date) && now.minutes < cutoff;
    var dispatch = cal.addWorking(sameDay ? now.date : cal.nextWorking(now.date), processing);
    var min = Math.max(0, Number(zone.min) || 0);
    var max = Math.max(min, Number(zone.max) || 0);
    var today = sameDay && processing === 0;
    return {
      today: now.date,
      dispatch: dispatch,
      dispatchToday: today,
      minutesLeft: today ? cutoff - now.minutes : 0,
      from: cal.addWorking(dispatch, min),
      to: cal.addWorking(dispatch, max)
    };
  }

  function weekday(d) { return d.toLocaleDateString('en-IE', { weekday: 'short', timeZone: 'UTC' }); }
  function dayLabel(d) { return weekday(d) + ' ' + d.getUTCDate() + ' ' + d.toLocaleDateString('en-IE', { month: 'short', timeZone: 'UTC' }); }
  function windowLabel(r) {
    if (key(r.from) === key(r.to)) return dayLabel(r.from);
    if (r.from.getUTCMonth() === r.to.getUTCMonth()) return weekday(r.from) + ' ' + r.from.getUTCDate() + ' – ' + dayLabel(r.to);
    return dayLabel(r.from) + ' – ' + dayLabel(r.to);
  }
  function timeLeft(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (!h) return Math.max(m, 1) + 'm';
    return h + 'h' + (m ? ' ' + m + 'm' : '');
  }
  /* Returns [before, highlighted, after] so the time or day can be emphasised without innerHTML */
  function dispatchParts(r, cfg) {
    var tpl, token, value;
    if (r.dispatchToday) {
      tpl = cfg.countdown || 'Order within [time] for dispatch today';
      token = '[time]'; value = timeLeft(r.minutesLeft);
    } else {
      tpl = cfg.nextDispatch || 'Order now for dispatch [day]';
      token = '[day]';
      value = key(addDays(r.today, 1)) === key(r.dispatch)
        ? (cfg.tomorrow || 'tomorrow')
        : r.dispatch.toLocaleDateString('en-IE', { weekday: 'long', timeZone: 'UTC' });
    }
    var at = tpl.indexOf(token);
    return at < 0 ? [tpl, '', ''] : [tpl.slice(0, at), value, tpl.slice(at + token.length)];
  }

  /* ---- UI ---- */
  var STORE_KEY = 'amfa:delivery-postcode';
  function store(v) { try { v ? localStorage.setItem(STORE_KEY, v) : localStorage.removeItem(STORE_KEY); } catch (e) {} }
  function stored() { try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } }

  function init(el) {
    if (el.__amfaDelivery) return;
    var cfgEl = el.querySelector('[data-delivery-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    el.__amfaDelivery = true;
    cfg.zones = (cfg.zones || []).filter(function (z) { return z.enabled !== false; });

    var input = el.querySelector('[data-zip]');
    var btn = el.querySelector('[data-zip-check]');
    var zoneOut = el.querySelector('[data-zone]');
    var win = el.querySelector('[data-window]');
    var countdown = el.querySelector('[data-countdown]');
    var err = el.querySelector('[data-delivery-error]');
    var list = el.querySelector('[data-zone-list]');
    var active = null;
    var errored = false;

    /* Before a postcode is entered: the full range across Irish zones */
    var irish = cfg.zones.filter(function (z) { return z.id.indexOf('ie') === 0; });
    var fallback = {
      label: cfg.defaultLabel,
      min: Math.min.apply(null, irish.map(function (z) { return Number(z.min) || 0; }).concat([99])),
      max: Math.max.apply(null, irish.map(function (z) { return Number(z.max) || 0; }).concat([0]))
    };
    if (fallback.min === 99) { fallback.min = 1; fallback.max = 3; }

    var rows = [];
    if (list) {
      cfg.zones.forEach(function (z) {
        var li = document.createElement('li');
        var name = document.createElement('span');
        var when = document.createElement('span');
        name.textContent = z.label;
        when.className = 'amfa-delivery__zone-date';
        li.appendChild(name); li.appendChild(when);
        list.appendChild(li);
        rows.push({ zone: z, li: li, when: when });
      });
    }

    function setCountdown(parts) {
      if (!countdown) return;
      countdown.textContent = '';
      countdown.appendChild(document.createTextNode(parts[0]));
      if (parts[1]) {
        var b = document.createElement('span');
        b.className = 'amfa-delivery__time';
        b.textContent = parts[1];
        countdown.appendChild(b);
      }
      countdown.appendChild(document.createTextNode(parts[2]));
    }

    function render() {
      var now = irishNow();
      var r = estimate(active ? active.zone : fallback, cfg, now);
      setCountdown(dispatchParts(r, cfg));
      rows.forEach(function (row) {
        row.when.textContent = windowLabel(estimate(row.zone, cfg, now));
        var on = !!active && active.zone.id === row.zone.id;
        row.li.classList.toggle('is-active', on);
        if (on) row.li.setAttribute('aria-current', 'true'); else row.li.removeAttribute('aria-current');
      });
      if (errored) return;
      if (win) win.textContent = windowLabel(r);
      if (zoneOut) zoneOut.textContent = active ? active.zone.label + ' · ' + active.formatted : fallback.label;
    }

    function showError(message) {
      errored = true;
      active = null;
      if (err) { err.textContent = message; err.hidden = false; }
      if (input) input.setAttribute('aria-invalid', 'true');
      if (win) win.textContent = '—';
      if (zoneOut) zoneOut.textContent = fallback.label;
    }
    function clearError() {
      errored = false;
      if (err) { err.textContent = ''; err.hidden = true; }
      if (input) input.removeAttribute('aria-invalid');
    }

    function check(opts) {
      var res = classify(input ? input.value : '', cfg);
      if (res.error === 'empty') {
        active = null; clearError(); store(''); render();
        return;
      }
      if (res.error) {
        if (!(opts && opts.silent)) showError(res.error === 'unsupported' ? cfg.unsupported : cfg.invalid);
        render();
        return;
      }
      clearError();
      active = res;
      if (input) input.value = res.formatted;
      store(res.formatted);
      render();
    }

    if (btn) btn.addEventListener('click', function () { check(); });
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(); }
      });
      input.addEventListener('input', function () { if (errored) clearError(); });
      var saved = stored();
      if (saved && !input.value) input.value = saved;
    }

    if (input && input.value) check({ silent: true }); else render();

    /* Keep the countdown and dates honest as the cut-off passes */
    var timer = setInterval(function () {
      if (!document.body.contains(el)) { clearInterval(timer); return; }
      render();
    }, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-delivery]').forEach(init);
  }

  window.AmfaDelivery = {
    init: init, classify: classify, estimate: estimate, windowLabel: windowLabel,
    dispatchParts: dispatchParts, holidays: holidays, irishNow: irishNow, utc: utc, key: key
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target.closest('.shopify-section') || document); });
})();
